module.exports = require("./gd-GB.js");